import React from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Button,
  Col,
  Grid,
  Input,
  Modal,
  Row,
  Typography,
} from 'antd';
import { integerRegExp } from 'utils/patterns';
import {
  ArrowLeftOutlined,
  FormOutlined,
} from '@ant-design/icons';

const { Text } = Typography;

const ModalDuplicate = ({
  onDuplicate,
  onCancel,
  form,
  contentUser,
  open,
  puesto,
  loading,
}) => {
  const screens = Grid.useBreakpoint();
  return (
    <Modal
      initialValues={{ clave: contentUser[0], puesto: contentUser[1] }}
      width="35%"
      title={(
        <Row justify="space-between">
          <Text>
            Duplicar Plaza
          </Text>
          <Row className="form-submit-controls">
            <Button
              type="link"
              onClick={onCancel}
              disabled={loading}
            >
              <ArrowLeftOutlined />
              {screens.md && 'Cancelar'}
            </Button>
            <Button
              type="link"
              onClick={onDuplicate}
              disabled={loading}
            >
              <FormOutlined />
              {screens.md && 'Duplicar Plaza'}
            </Button>
          </Row>
        </Row>
    )}
      className="modal-delete"
      open={open}
      footer={null}
      closable={false}
      maskClosable={!loading}
      keyboard={!loading}
      destroyOnClose
    >
      <Form
        layout="vertical"
        form={form}
        name="general"
      >
        <Text style={{ fontSize: 16 }}>
          ¿Desea Duplicar La Plaza
          {' '}
          {contentUser[0]}
          ?
        </Text>
        <Col span={24}>
          <Form.Item
            label="No. de Plaza"
            name="clave"
          >
            <Input
              disabled
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={24}>
          <Form.Item
            label="Puesto"
          >
            <Input
              disabled
              value={puesto}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={24}>
          <Form.Item
            label="No. de Copias"
            name="no_copias"
            rules={[
              { required: true, message: 'El campo es requerido' },
              {
                pattern: integerRegExp, message: 'Ingrese un valor válido',
              },
              {
                validator: async () => {
                  const { no_copias } = form.getFieldsValue();
                  if (no_copias > 50) {
                    throw new Error('50 es el máximo de copias');
                  }
                },
              },
            ]}
            hasFeedback
          >
            <Input />
          </Form.Item>
        </Col>
        <Form.Item hidden>
          <Button htmlType="submit" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

ModalDuplicate.propTypes = {
  onDuplicate: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  contentUser: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]).isRequired,
  open: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  form: PropTypes.object.isRequired,
  loading: PropTypes.bool,
  puesto: PropTypes.string,
};

ModalDuplicate.defaultProps = {
  open: false,
  loading: false,
  puesto: '',
};

export default ModalDuplicate;
